module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/json-loader!./.cache/json/layouts-bullseye.json
// module id = 1058
// module chunks = 69764908170624